<script setup>
import AdvancedNotificationManager from '@/views/apps/notification/list/AdvancedNotificationManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'notifications',
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})
</script>

<template>
  <AdvancedNotificationManager />
</template>
